<script lang="ts">
</script>

<div class="twism-loading-container">
  <div class="twism-loading-container__internal-circle" />
  <div class="twism-loading-container__bullet" />
</div>

<style lang="scss">
  .twism-loading-container {
    position: relative;
    width: 64px;
    height: 64px;
    border-radius: 64px;
    background: conic-gradient(
      from 180deg at 50% 50%,
      var(--twism-theme-primary200) 0deg,
      rgba(0, 124, 234, 0) 360deg
    );
    transform: matrix(-1, 0, 0, 1, 0, 0);
    display: flex;
    align-items: center;
    justify-content: center;

    &__internal-circle {
      background-color: #fff;
      height: 41.6px;
      width: 41.6px;
      border-radius: 42px;
    }
    &__bullet {
      background-color: var(--twism-theme-primary200);
      height: 11.2px;
      width: 11.2px;
      border-radius: 12px;
      position: absolute;
      bottom: 0;
    }
  }
</style>
